/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_Tenant_SwitchInputs */

const es_sidebar_tenant_switch = /** @type {(inputs: Sidebar_Tenant_SwitchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambiar Empresa`)
};

const en_sidebar_tenant_switch = /** @type {(inputs: Sidebar_Tenant_SwitchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Switch Tenant`)
};

/**
* | output |
* | --- |
* | "Switch Tenant" |
*
* @param {Sidebar_Tenant_SwitchInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const sidebar_tenant_switch = /** @type {((inputs?: Sidebar_Tenant_SwitchInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_Tenant_SwitchInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_sidebar_tenant_switch(inputs)
	return en_sidebar_tenant_switch(inputs)
});
export { sidebar_tenant_switch as "sidebar.tenant_switch" }